/**
 * @file: index.
 * @intro: storage存储.
 * @author: zzmhot.
 * @email: zzmhot@163.com.
 * @Date: 2017/4/28 10:42.
 * @Copyright(©) 2017 by zzmhot.
 *
 */

import {localStorage, sessionStorage} from './storage'
import cookieStorage from './cookie'

export {
  localStorage,
  sessionStorage,
  cookieStorage
}



// WEBPACK FOOTER //
// ./src/common/storage/index.js